/**
 * Design Tokens - Border Radius
 * Exported from Figma: Enersee Platform 2.0 - _Foundation_DesignSystem
 *
 * Border radius values for consistent rounded corners.
 */

export const radiusTokens = {
  xs: '4px', // radius-xs
  sm: '6px', // radius-sm
  md: '8px', // radius-md
  xl: '12px', // radius-xl
  '3xl': '20px', // radius-3xl
  full: '9999px', // radius-full
} as const;

export type RadiusTokens = typeof radiusTokens;
